// Hands a picked file from the Home "+ POST" shortcut to the LXN WRLD media uploader.
let pending = null;
export const setPendingUpload = (file) => { pending = file; };
export const takePendingUpload = () => { const f = pending; pending = null; return f; };
